import { Link } from "react-router-dom";

import { pendingApprovalExplanation, pendingApprovalHeadline } from "../lib/registrationInbox";
import "./pendingApprovalNotice.css";

/** Aviso de inscripciones sin aprobar (caso Tecamachalco, 2026-10-27): la
 * bienvenida con usuario y contraseña sale al aprobar; si el organizador no
 * aprueba, el jugador nunca recibe su acceso. Sin aprobación masiva: el botón
 * solo lleva a la lista filtrada. No se muestra con cero pendientes. */
type Props = {
  total: number;
  paid: number;
  autoSendWelcome: boolean;
  /** Botón dentro de Inscripciones (filtra la lista)… */
  onShow?: () => void;
  /** …o liga desde el inicio del torneo. */
  to?: string;
  /** Con el filtro puesto, el botón lo quita. */
  showingPending?: boolean;
};

export default function PendingApprovalNotice({ total, paid, autoSendWelcome, onShow, to, showingPending = false }: Props) {
  if (total <= 0) return null;
  const label = showingPending ? "Ver todas" : "Ver pendientes";
  return (
    <div className="t123-pending-approval" role="status" data-no-toast>
      <div className="t123-pending-approval__text">
        <strong>{pendingApprovalHeadline({ total, paid })}</strong>
        <span>{pendingApprovalExplanation(autoSendWelcome)}</span>
      </div>
      {to ? (
        <Link className="t123-pending-approval__action" to={to}>
          {label}
        </Link>
      ) : onShow ? (
        <button className="t123-pending-approval__action" type="button" onClick={onShow} aria-pressed={showingPending}>
          {label}
        </button>
      ) : null}
    </div>
  );
}
